import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsive, responsiveContainer } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const firstLetterCapitalStyle = style({
  selectors: {
    "&:first-letter": {
      textTransform: "uppercase",
    },
  },
});

export const plusHeadingStyle = style({
  paddingRight: theme.spacings.xl,
  maxWidth: rem(420),
});

/**
 * Vertical spacing between plus points, scaling up from mobile to desktop.
 */
export const plusPointsListStyle = style({
  gap: theme.spacings.s,
  ...responsive({
    s: { gap: theme.spacings.m },
    m: { gap: theme.spacings.l },
  }),
});

/**
 * On mobile (stacked) a top offset adds breathing room below the heading;
 * removed once the heading and list sit side by side at the grid's breakpoint.
 */
export const plusPointsOffsetStyle = style({
  marginTop: theme.spacings.m,
  ...responsiveContainer({
    500: {
      marginTop: 0,
    },
  }),
});
